"use client";

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faTrash, faWallet } from "@fortawesome/free-solid-svg-icons";
import { CommunityMemberMinimal } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { dedupeWallets, walletListsMatch } from "@/helpers/WalletHelpers";
import { AuthContext } from "@/components/auth/Auth";
import GroupCreateIdentitiesSelect from "../identities/select/GroupCreateIdentitiesSelect";
import CreateGroupWalletsEmma from "./CreateGroupWalletsEmma";
import CreateGroupWalletsUpload from "./CreateGroupWalletsUpload";
import { useContext, useEffect, useRef, useState } from "react";
export enum GroupCreateWalletsType {
  INCLUDE = "INCLUDE",
  EXCLUDE = "EXCLUDE",
}
export default function GroupCreateWallets(t0) {
  const $ = _c(67);
  const {
    type,
    wallets,
    walletsLimit,
    iAmIncluded,
    setWallets
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const primaryWallet = connectedProfile?.primary_wallet;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [GroupCreateWalletsType.INCLUDE]: "Include Identities",
      [GroupCreateWalletsType.EXCLUDE]: "Exclude Identities"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  const [uploadedWallets, setUploadedWallets] = useState(wallets);
  const uploadedWalletsRef = useRef(uploadedWallets);
  const [emmaWallets, setEmmaWallets] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [selectedIdentities, setSelectedIdentities] = useState(t2);
  let t3;
  if ($[2] !== selectedIdentities) {
    t3 = () => selectedIdentities.map(_temp);
    $[2] = selectedIdentities;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getSelectedWallets = t3;
  let t4;
  if ($[4] !== getSelectedWallets) {
    t4 = getSelectedWallets();
    $[4] = getSelectedWallets;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [selectedWallets, setSelectedWallets] = useState(t4);
  const walletsRef = useRef(wallets);
  let t5;
  let t6;
  if ($[6] !== uploadedWallets) {
    t5 = () => {
      uploadedWalletsRef.current = uploadedWallets;
    };
    t6 = [uploadedWallets];
    $[6] = uploadedWallets;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[9] !== wallets) {
    t7 = () => {
      walletsRef.current = wallets;
    };
    t8 = [wallets];
    $[9] = wallets;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[12] !== wallets) {
    t9 = () => {
      if (!wallets?.length) {
        setUploadedWallets(null);
        return;
      }
      const dedupedWallets = dedupeWallets(wallets);
      if (walletListsMatch(dedupedWallets, uploadedWalletsRef.current)) {
        return;
      }
      setUploadedWallets(dedupedWallets);
    };
    t10 = [wallets];
    $[12] = wallets;
    $[13] = t10;
    $[14] = t9;
  } else {
    t10 = $[13];
    t9 = $[14];
  }
  useEffect(t9, t10);
  let t11;
  if ($[15] !== getSelectedWallets) {
    t11 = () => setSelectedWallets(getSelectedWallets());
    $[15] = getSelectedWallets;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== selectedIdentities) {
    t12 = [selectedIdentities];
    $[17] = selectedIdentities;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  useEffect(t11, t12);
  let t13;
  if ($[19] !== connectedProfile?.wallets || $[20] !== iAmIncluded || $[21] !== type) {
    t13 = () => {
      if (type === GroupCreateWalletsType.EXCLUDE || iAmIncluded) {
        return;
      }
      const myWallets = connectedProfile?.wallets?.map(_temp2)?.filter(Boolean) ?? [];
      setSelectedIdentities(prev => prev.filter(i_0 => {
        const key = (i_0.wallet ?? i_0.primary_wallet)?.toLowerCase();
        return !key || !myWallets.includes(key);
      }));
    };
    $[19] = connectedProfile?.wallets;
    $[20] = iAmIncluded;
    $[21] = type;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== connectedProfile || $[24] !== iAmIncluded || $[25] !== type) {
    t14 = [iAmIncluded, connectedProfile, type];
    $[23] = connectedProfile;
    $[24] = iAmIncluded;
    $[25] = type;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  useEffect(t13, t14);
  const toKey = _temp3;
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = identity => {
      setSelectedIdentities(prev_0 => {
        const target = toKey(identity);
        if (!target) {
          return prev_0;
        }
        if (prev_0.some(i_3 => toKey(i_3) === target)) {
          return prev_0.filter(i_2 => toKey(i_2) !== target);
        }
        return [...prev_0, identity];
      });
    };
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const onIdentitySelect = t15;
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = newV => setUploadedWallets(newV ? dedupeWallets(newV) : null);
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const onUploadedWalletsChange = t16;
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = newV_0 => setEmmaWallets(newV_0 ? dedupeWallets(newV_0) : null);
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const onEmmaWalletsChange = t17;
  let t18;
  let t19;
  if ($[30] !== emmaWallets || $[31] !== iAmIncluded || $[32] !== primaryWallet || $[33] !== selectedWallets || $[34] !== setWallets || $[35] !== type || $[36] !== uploadedWallets) {
    t18 = () => {
      const uploaded = uploadedWallets ?? [];
      const emma = emmaWallets ?? [];
      const selected = selectedWallets ?? [];
      const combined = [...uploaded, ...emma, ...selected];
      if (iAmIncluded && primaryWallet && type === GroupCreateWalletsType.INCLUDE) {
        combined.push(primaryWallet);
      }
      const dedupedAll = combined.length ? dedupeWallets(combined) : [];
      const next = dedupedAll.length ? dedupedAll : null;
      if (!walletListsMatch(next, walletsRef.current)) {
        setWallets(next);
      }
    };
    t19 = [uploadedWallets, emmaWallets, selectedWallets, iAmIncluded, primaryWallet, type, setWallets];
    $[30] = emmaWallets;
    $[31] = iAmIncluded;
    $[32] = primaryWallet;
    $[33] = selectedWallets;
    $[34] = setWallets;
    $[35] = type;
    $[36] = uploadedWallets;
    $[37] = t18;
    $[38] = t19;
  } else {
    t18 = $[37];
    t19 = $[38];
  }
  useEffect(t18, t19);
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => {
      setUploadedWallets(null);
      setEmmaWallets(null);
      setSelectedIdentities([]);
    };
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  const removeWallets = t20;
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = wallet => {
      const target_0 = wallet.toLowerCase();
      setSelectedIdentities(prev_1 => prev_1.filter(i_4 => ((i_4.wallet ?? i_4.primary_wallet)?.toLowerCase() ?? "") !== target_0));
    };
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const onRemove = t21;
  const isOverLimit = (wallets?.length ?? 0) > walletsLimit;
  let t22;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-size-10 sm:tw-size-11 tw-bg-iron-950 tw-border tw-border-solid tw-border-iron-700"><FontAwesomeIcon icon={faWallet} aria-hidden="true" className="tw-flex-shrink-0 tw-text-iron-50 tw-size-5 sm:tw-size-6" /></span>;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  const t23 = LABELS[type];
  let t24;
  if ($[42] !== t23) {
    t24 = <div className="tw-inline-flex tw-items-center tw-space-x-3 sm:tw-space-x-4">{t22}<p className="tw-mb-0 tw-text-xl sm:tw-text-2xl tw-font-semibold tw-text-iron-50">{t23}</p></div>;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== selectedIdentities || $[45] !== selectedWallets) {
    t25 = <GroupCreateIdentitiesSelect onIdentitySelect={onIdentitySelect} selectedIdentities={selectedIdentities} selectedWallets={selectedWallets} onRemove={onRemove} />;
    $[44] = selectedIdentities;
    $[45] = selectedWallets;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== emmaWallets) {
    t26 = <CreateGroupWalletsEmma setWallets={onEmmaWalletsChange} wallets={emmaWallets} />;
    $[47] = emmaWallets;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== type || $[50] !== uploadedWallets) {
    t27 = <CreateGroupWalletsUpload type={type} setWallets={onUploadedWalletsChange} wallets={uploadedWallets} />;
    $[49] = type;
    $[50] = uploadedWallets;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t25 || $[53] !== t26 || $[54] !== t27) {
    t28 = <div className="tw-mt-4 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4 sm:tw-gap-6">{t25}{t26}{t27}</div>;
    $[52] = t25;
    $[53] = t26;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== isOverLimit || $[57] !== wallets) {
    t29 = !!wallets?.length && <div className="tw-mt-4 tw-w-full md:tw-w-1/2 sm:tw-pr-4"><div className="tw-w-full tw-flex tw-items-center tw-gap-x-4"><div className={`tw-w-full tw-px-4 tw-py-3 tw-flex tw-justify-between tw-gap-x-4 tw-items-center tw-rounded-xl ${isOverLimit ? " tw-border-error" : " tw-border-iron-400"} tw-bg-iron-950 tw-border tw-border-solid`}><div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm"><FontAwesomeIcon icon={faWallet} aria-hidden="true" className="tw-size-6 tw-flex-shrink-0 tw-text-iron-300" /><span className="tw-inline-flex tw-gap-x-1.5"><span className="tw-text-iron-50 tw-font-medium">Total unique wallets:</span><span className={`tw-font-semibold ${isOverLimit ? "tw-text-error" : "tw-text-primary-400"}`}>{formatNumberWithCommas(wallets.length)}</span></span></div></div><button onClick={removeWallets} type="button" aria-label="Remove wallets" className="tw-rounded-full tw-group tw-flex tw-items-center tw-justify-center tw-p-2 tw-text-xs tw-font-medium tw-border-none tw-ring-1 tw-ring-inset tw-text-iron-400 tw-bg-iron-900 tw-ring-iron-700 hover:tw-ring-iron-650 tw-transition tw-duration-300 tw-ease-out"><FontAwesomeIcon icon={faTrash} aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-error tw-transition tw-duration-300 tw-ease-out" /></button></div></div>;
    $[56] = isOverLimit;
    $[57] = wallets;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== isOverLimit || $[60] !== walletsLimit) {
    t30 = isOverLimit && <div className="tw-pt-2 tw-text-error tw-text-xs tw-font-medium"><div className="tw-flex tw-items-center tw-gap-x-2"><FontAwesomeIcon icon={faCircleExclamation} aria-hidden="true" className="tw-size-5 tw-flex-shrink-0 tw-text-error" /><span>Maximum allowed wallets count is{" "}{formatNumberWithCommas(walletsLimit)}</span></div></div>;
    $[59] = isOverLimit;
    $[60] = walletsLimit;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] !== t24 || $[63] !== t28 || $[64] !== t29 || $[65] !== t30) {
    t31 = <div className="tw-col-span-full">{t24}{t28}{t29}{t30}</div>;
    $[62] = t24;
    $[63] = t28;
    $[64] = t29;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  return t31;
}
function _temp3(i_1) {
  return (i_1.wallet ?? i_1.primary_wallet)?.toLowerCase();
}
function _temp2(w) {
  return w.wallet?.toLowerCase();
}
function _temp(i) {
  return i.wallet ?? i.primary_wallet;
}